// pages/AgendaPage.js o donde desees usarlo
import React from 'react';
import { Box } from '@mui/material';
import Valorizaciones from '../../components/administration/valuations/ValuationsDashboard';

const ValorizacionesPage = () => {
    return (
        <Box sx={{ p: 2 }}>
            <Valorizaciones
                onReorder={(newOrder) => {
                    console.log('Nuevo vista de valorizaciones:', newOrder);
                }}
            />
        </Box>
    );
};

export default ValorizacionesPage;
